import Loader from '../../../_modules/loader/loader';
import ProductDetails from '../../../_modules/product-details/product-details';
import PoNumber from '../../../_modules/po-number/po-number';
import {
    isFieldEmpty,
    displayErrors,
    displayInputError
} from './_helper';
import {
    toaster
} from './_material';
import 'moment';

if ($('.view-regimen').length) {
    let productDetails = new ProductDetails();
    productDetails.init();

    let $body = $('body'),
        $editPaymentModal = $('.form-modal--edit-payment'),
        $editProductsModal = $('.form-modal--edit-products'),
        $regimenId = $('#RegimenId'),
        $selectedPoNumber = $('.PoNumber__list'),
        $allDeliveryFree = $('#AllDeliveryFree'),
        $startLaterDateInputGroup = $('.regimen-start--later__input'),
        $startToday = $('#StartToday'),
        $startLater = $('#StartLater'),
        $startDateInput = $('#NewStartDate'),
        $nextRequestedOrderDateInput = $('#RequestedNextOrderDate'),
        $editBtnPurchaseOrder = $('div[data-modal-class="form-modal--edit-purchaseordernumber"] div.form--edit__link, #ReadonlyPurchaseOrderNumber'),
        _isInvalid = [],
        loader = new Loader(),
        dataParams = {},
        startDate,
        nextRequestedOrderDate,
        $cancellationReason = $('#CancellationReason'),
        $cancellationReasonOther = $('#CancellationReasonOther'),
        $agreementSent = $("#AgreementSent"),
        $agreementSentIncidentNumber = $("#AgreementIncidentNumber"),
        $agreementStatus = $("#AgreementStatus"),
        $agreementStatusCallLog = $("#AgreementStatusCallLogNumber"),
        $ndisDataOptInPanel = $(".ndis-agreement-optin"),
        $ndisDataOptIn = $("#NDISDataOptIn"),
        $tenderSetting = $("#TenderSetting"),
        _tenderSetting = $tenderSetting.length > 0 ? JSON.parse($tenderSetting.val()) : null;

    
    //if cancellation reason is changed to other show textbox
    $cancellationReason.on("change", function(){
        let $this = $(this);
        if($this.val() == "Other") {
            $cancellationReasonOther.removeClass("hidden");
            $cancellationReasonOther.prop("required", true);
        } else {
            $cancellationReasonOther.addClass("hidden");
            $cancellationReasonOther.prop("required", false);
        }
    });
    
    $agreementSent.on("change", function(e){
        e.preventDefault();
        let $this = $(this);
        if($this.prop("checked")) {
            $(".agreement-sent, .ndis-agreement-status").removeClass("hidden");
            $agreementSentIncidentNumber.prop("required", true);
        } else {
            $(".agreement-sent, .ndis-agreement-status").addClass("hidden");
            $agreementSentIncidentNumber.prop("required", false);
        }
    });
    
    $agreementStatus.on("change", function(e){
        e.preventDefault();
        let $this = $(this);
        $ndisDataOptInPanel.addClass("hidden");
        $ndisDataOptIn.prop("checked", false);
        $agreementStatusCallLog.prop("required", false);
        if($this.val() > 0) {
            $(".agreement-agreed").removeClass("hidden");
            $agreementStatusCallLog.prop("required", true);
            if($(this).val() == "2") {
                $ndisDataOptInPanel.removeClass("hidden");
            }
            if($(this).val() == "1") {
                $ndisDataOptIn.prop("checked", true);
            }
        } else {
            $(".agreement-agreed").addClass("hidden");
        }
    });

    $(".js-regimen-ndis-agreement").on("click", function(e){
        e.preventDefault();
        let $this = $(this),
            token = $this.parent().find('input[name=__RequestVerificationToken]').val(),
            apiUrl = $this.data('api'),
            dataParams = {};
    
        let $errorContainer = $this.parent().parent().siblings('.server-errors__wrap')
        _isInvalid = [];
        // Define Obj as property name changes according to input
        dataParams.RegimenId = $regimenId.val();
        dataParams.AgreementSent = $agreementSent.prop("checked");
        dataParams.AgreementSentIncidentNumber = $agreementSentIncidentNumber.val();
        dataParams.AgreementStatus = $agreementStatus.val();
        dataParams.AgreementStatusCallLogNumber = $agreementStatusCallLog.val();
        dataParams.DataOptIn = $ndisDataOptIn.prop("checked");

        if(dataParams.AgreementSent && isFieldEmpty($agreementSentIncidentNumber)) {
            $agreementSentIncidentNumber
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
            _isInvalid.push(0);
        }

        
        if(dataParams.AgreementStatus > 0 && isFieldEmpty($agreementStatusCallLog)) {
            $agreementStatusCallLog
                .parent().addClass('incomplete')
                .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
            _isInvalid.push(0);
        }

        if(_isInvalid.length > 0){
            toaster('Please complete mandatory fields.', 'error');
            return;
        }
        
        loader.fadeIn();
    
        $.ajax({
            url: apiUrl,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'POST',
            headers: { __RequestVerificationToken: token },
            data: JSON.stringify(dataParams),
            success: function (data) {
                toaster( "Nutrition plan's NDIS agreement details have been updated!");
                loader.fadeOut();
    
                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
    
                window.location.href = data.href;
            },
            error: function (error) {
                loader.fadeOut();
                displayErrors(error, $errorContainer );
            }
        });
    });

    // Cancel Regimen
    $('.js-cancel-regimen').on('click', function (e) {
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        $.fancybox.open('#cancel-regimen', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterShow: function () {
                $('.js-agree-cancel-regimen').on('click', function (e) {
                    $.fancybox.close();

                    setTimeout(function () {
                        $('#cancel-regimen__form').submit();
                    }, 100);
                });
            }
        });
    });

    $('.js-agree-cancel-regimen').on('click', function (e){
        e.preventDefault();
    
        let $this = $(this),
            inputId = $this.data('input'),
            $input = $('#' + inputId),
            $inputOther = $('#CancellationReasonOther'),
            propertyName = $this.data('property'),
            token = $this.parent().find('input[name=__RequestVerificationToken]').val(),
            apiUrl = $this.data('api'),
            dataParams = {};
    
        let $errorContainer = $this.parent().parent().siblings('.server-errors__wrap')
    
        // Define Obj as property name changes according to input
        dataParams.RegimenId = $regimenId.val();
        dataParams[propertyName] = $input.val();
        if(dataParams[propertyName] == "Other") {
            dataParams[propertyName] = $inputOther.val();
        }

        if(dataParams[propertyName] == ""){
            toaster('Please provide a reason.', 'error');
            return;
        }
        
        loader.fadeIn();
    
        $.ajax({
            url: apiUrl,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'PUT',
            headers: { __RequestVerificationToken: token },
            data: JSON.stringify(dataParams),
            success: function (data) {
                toaster( 'Nutrition plan has been cancelled!');
                loader.fadeOut();
    
                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
    
                window.location.href = data.href;
            },
            error: function (error) {
                loader.fadeOut();
                displayErrors(error, $errorContainer );
            }
        });
    });


    $('.js-create-next-order-in-advance').on('click', function (e) {
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        $.fancybox.open('#create-next-order-in-advance', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterShow: function () {
                $('.js-agree-create-next-order-in-advance').on('click', function (e) {
                    $.fancybox.close();

                    setTimeout(function () {
                        $('#create-next-order-in-advance__form').submit();
                    }, 100);
                });
            }
        });
    });

    // Hold Regimen
    $('.js-hold-regimen').on('click', function (e) {
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        $.fancybox.open('#hold-regimen', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterShow: function () {
                $('.js-agree-hold-regimen').on('click', function (e) {
                    $.fancybox.close();

                    setTimeout(function () {
                        $('#hold-regimen__form').submit();
                    }, 100);
                });
            }
        });
    });

    // UnHold Regimen
    $('.js-unhold-regimen').on('click', function (e) {
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        $('.off-hold-next-order-date')
            .slideUp({
            duration: 500,
            easing: 'easeInOutExpo',
            queue: false
        });

        $.fancybox.open('#unhold-regimen', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterShow: function () {
                if ($('#unhold-regimen').length > 0) {
                    $('.fancybox-inner').css('overflow', 'visible');
                }
                $('.js-agree-unhold-regimen').on('click', function (e) {
                    if($('#NextOrderDateInput').val() == 'N/A' || $('#NextOrderDateInput').val() == ''){

                      $('.off-hold-next-order-date')
                          .slideDown({
                          duration: 500,
                          easing: 'easeInOutExpo',
                          queue: false
                      });

                    }else{

                      $('.off-hold-next-order-date')
                          .slideUp({
                          duration: 500,
                          easing: 'easeInOutExpo',
                          queue: false
                      });

                      $.fancybox.close();

                      $('#NextOrderDate').val($('#NextOrderDateInput').val()); //todo set value from fancybox datepicker (get FE to make fancybox datepicker look nice)
                      setTimeout(function () {
                          $('#unhold-regimen__form').submit();
                      }, 100);
                    }
                });
            }
        });

    });

    // Archive Regimen
    $('.js-archive-regimen').on('click', function (e) {
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        $.fancybox.open('#archive-regimen', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterShow: function () {
                $('.js-agree-archive-regimen').on('click', function (e) {
                    $.fancybox.close();

                    setTimeout(function () {
                        $('#archive-regimen__form').submit();
                    }, 100);
                });
            }
        });
    });

    //Delete payment token
    $('.js-delete-payment-token').on('click', function (e) {
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        $.fancybox.open('#delete-payment-token', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterShow: function () {
                $('.js-agree-delete-payment-token').on('click', function (e) {
                    $.fancybox.close();

                    setTimeout(function () {
                        $('#delete-payment-token__form').submit();
                    }, 100);
                });
            }
        });
    });

    // Reinstate Regimen
    $('.js-reinstate-regimen').on('click', function (e) {
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)');

        $.fancybox.open('#reinstate-regimen', {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterShow: function () {
                $('.js-agree-reinstate-regimen').on('click', function (e) {
                    $.fancybox.close();

                    setTimeout(function () {
                        $('#reinstate-regimen__form').submit();
                    }, 100);
                });
            }
        });
    });

    let regimenDateDetails = function (showDisclaimer, showInputDate) {

        //     showing/hiding input regimen start date  based on the start later radio button state.
        switch (showInputDate) {
            case 'showInput':
                $startLaterDateInputGroup
                    .addClass('visible');
                break;
            case 'hideInput':
                $startLaterDateInputGroup
                    .removeClass('visible');
                break;
        }

        //     showing/hiding disclaimer based on the start immediatelly radio button state.
        switch (showDisclaimer) {
            case 'showDisclaimer':
                $('.start-today__disclaimer')
                    .slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });
                break;
            case 'hideDisclaimer':
                $('.start-today__disclaimer')
                    .slideUp({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });
                break;
        }
    };

    /* Define start date for a regimen.
     ** Default date is the one selected when regimen was created.
     ** Need to change expiry date accordingly */
    $startToday.on('change', function (e) {

        switch ($('#StartToday').is(':checked')) {
            case true:
                regimenDateDetails('showDisclaimer', 'hideInput');
                startDate = moment().format('DD-MM-YYYY');
                $startDateInput
                    .prop('disabled', true)
                    .val(startDate);
                break;
            case false:
                regimenDateDetails('hideDisclaimer', 'showInput');
                break;
        }

    });

    $startLater.on('change', function () {

        switch ($('#StartLater').is(':checked')) {
            case true:
                regimenDateDetails('hideDisclaimer', 'showInput');
                $startDateInput
                    .removeAttr('disabled')
                    .val($('#StartDate').val());
                $('.regimen-datepicker').pickadate('picker').open();
                break;
            case false:
                regimenDateDetails('showDisclaimer', 'hideInput');
                break;
        }


    });

    $('div[data-modal-class="form-modal--edit-date"]').on('click', function () {

        $startLater.prop('checked', true);
        switch ($('#StartLater').is(':checked')) {
            case true:
                regimenDateDetails('hideDisclaimer', 'showInput');
                $startDateInput
                    .removeAttr('disabled')
                    .val($('#StartDate').val());
                $('.regimen-datepicker').pickadate('picker').open();
                break;
            case false:
                regimenDateDetails('showDisclaimer', 'hideInput');
                break;
        }
    });

    //Update expiry date if different date is selected
    $('body').on('change', '.regimen-datepicker', function (e) {

        startDate = $startDateInput.val();
        nextRequestedOrderDate = $nextRequestedOrderDateInput.val();
    });

    // Call api to set new Start Date value
    $('.js-update-date').on('click', function (e) {
        e.preventDefault();

        if (isFieldEmpty($startDateInput)) {

            $(this)
                .addClass('error')
                .siblings('.validation--message')
                .slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
            return false;
        } else {
            startDate = $startDateInput.val();
        }

        //define where to display AJAX errors
        let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

        loader.fadeIn();
        dataParams = {
            'RegimenId': $regimenId.val(),
            'StartDate': startDate
        };

        $.ajax({
            url: '/api/regimens/updatestartdate',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: {
                __RequestVerificationToken: $editPaymentModal.find('input[name=__RequestVerificationToken]').val()
            },
            type: 'PUT',
            data: JSON.stringify(dataParams),
            success: function (data) {

                window.location.reload();

            },
            error: function (error) {
                loader.fadeOut();
                displayErrors(error, $errorContainer);
            }
        });
    });

    $('.js-undo-start-date').on('click', function (e) {
        e.preventDefault();

        let $this = $(this),
            $modal = $this.closest('.form-modal'),
            originalDate = $('#StartDate').val();

        $body.removeClass('fixed');

        $modal.slideUp({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });

        $startDateInput.val(originalDate);
        $startToday.prop('checked', false);
        $startLater.prop('checked', false);

        $('.start-today__disclaimer')
            .slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
    });


    $('.js-update-payment').on('click', function (e) {
        e.preventDefault();

        //define where to display AJAX errors
        let $errorContainer = $editPaymentModal.find('.server-errors__wrap'),
            $poNumberList = $('.PoNumber__list');

        let poNumber = new PoNumber();

        if (!poNumber.isValidPONumber('updatePayment'))
            return false;

        loader.fadeIn();
        dataParams = {
            'RegimenId': $regimenId.val(),
            'PaymentRuleId': $('.js-toggle-all-free.pay-selected').length == 1 ? null : $('.payment__list li.pay-selected').data('ruleid'),
            'AreAllOrdersFree': $('.js-toggle-all-free').parent().hasClass('pay-selected') ? true : false,
            "PurchaseOrderNumber": $poNumberList.val() == '' ? null : poNumber.getPONumber('updatePayment')
        };

        $.ajax({
            url: '/api/regimens/updatepayment',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: {
                __RequestVerificationToken: $editPaymentModal.find('input[name=__RequestVerificationToken]').val()
            },
            type: 'PUT',
            data: JSON.stringify(dataParams),
            success: function (data) {
                toaster('Payment option has been saved!');
                window.location.href = data.href;
                loader.fadeOut();

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
            },
            error: function (error) {
                loader.fadeOut();
                displayErrors(error, $errorContainer);
            }
        });
    });

    $('.js-update-products').on('click', function (e) {
        e.preventDefault();

        let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

        let productDetails = new ProductDetails();

        dataParams = {
            'RegimenId': $regimenId.val(),
            'Phases': productDetails.getSelectedProducts()
        };

        let isValid = true;
        if(_tenderSetting.QuantityType == "CartonSize") {
            for (let idx = 0; idx < dataParams.Phases.length; idx++) {
                const phElement = dataParams.Phases[idx];
                for (let index = 0; index < phElement.Products.length; index++) {
                    const prod = phElement.Products[index];
                    if(prod.Id == null && prod.ProductTypeId != null) {
                        isValid = false;
                    }
                }
            }
        }

        if(!isValid){
            displayErrors({responseJSON: 'Please select a flavour prior to clicking "save changes".'}, $errorContainer);
            return false;
        }

        loader.fadeIn();

        $.ajax({
            url: '/api/regimens/updateproducts',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: {
                __RequestVerificationToken: $editProductsModal.find('input[name=__RequestVerificationToken]').val()
            },
            type: 'PUT',
            data: JSON.stringify(dataParams),
            success: function (data) {
                loader.fadeOut();
                window.location.href = data.href;
                toaster('Data saved successfully.');

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
            },
            error: function (error) {
                loader.fadeOut();
                displayErrors(error, $errorContainer);
            }
        });

    });

    /* Make API call to set new input/textarea/select value.
     ** Used for modal windows and only 1 input in it */
    $('.js-update-regimen-value').on('click', function (e) {
        e.preventDefault();

        let newPo;

        //PO Number has additional validation
        if ($(this).data('property') === 'PurchaseOrderNumber') {

            let poNumber = new PoNumber();

            if (!poNumber.isValidPONumber('updatePo'))
                return false;

            newPo = poNumber.getPONumber('updatePo');
        }

        //Update Next Order Date validation
        if ($(this).data('property') === 'NextOrderDate') {
            if ($('#UpdateNextOrder').val() == 'N/A' || $('#UpdateNextOrder').val() == '')
            {
              $('.next-order-date')
                  .slideDown({
                  duration: 500,
                  easing: 'easeInOutExpo',
                  queue: false
              });

              return false;
            }
        }

        let $this = $(this),
            inputId = $this.data('input'),
            $input = $('#' + inputId),
            propertyName = $this.data('property'),
            token = $this.parent().find('input[name=__RequestVerificationToken]').val(),
            apiUrl = $this.data('api'),
            dataParams = {};

        let $errorContainer = $this.parent().parent().siblings('.server-errors__wrap');

        loader.fadeIn();

        //define Obj as property name chanes according to input
        dataParams.RegimenId = $regimenId.val();
        dataParams[propertyName] = $input.val();

        if ($(this).data('property') === 'PurchaseOrderNumber') {
            dataParams[propertyName] = newPo;
        }

        $.ajax({
            url: apiUrl,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'PUT',
            headers: {
                __RequestVerificationToken: token
            },
            data: JSON.stringify(dataParams),
            success: function (data) {

                toaster('Details have been saved!');
                loader.fadeOut();

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

                window.location.href = data.href;
            },
            error: function (error) {

                loader.fadeOut();
                displayErrors(error, $errorContainer);
            }
        });
    });

    /* Display popup if checkbox needs confirmation */
    $('.switch--fancybox').on('change', function (e) {
        e.preventDefault();

        let isMobileDevice = Modernizr.mq('(max-width: 767px)'),
            $this = $(this),
            fancyboxId = $this.data('fancybox');

        $.fancybox.open(fancyboxId, {
            autoSize: false,
            closeBtn: false,
            fitToView: false,
            height: isMobileDevice == true ? 300 : 200,
            width: isMobileDevice == true ? 250 : 500,
            padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
            type: 'inline',
            wrapCSS: 'modal',
            afterClose: function () {
                undoCheckbox($this);
            }
        });

    });

    /* Make API call to set new checkbox value.
     ** Used for fancybox associated with 1 checkbox */
    $('.js-confirm-change').on('click', function (e) {
        e.preventDefault();

        let $this = $(this),
            checkboxId = $this.data('checkbox'),
            $checkbox = $('#' + checkboxId),
            propertyName = $this.data('property'),
            newValue,
            token = $this.parent().find('input[name=__RequestVerificationToken]').val(),
            apiUrl = $this.data('api'),
            dataParams = {};

        // for deliveryFee needs to pass the type, not the boolean value
        if (checkboxId === 'AllDeliveryFree')
            newValue = setDeliveryFeeType();
        else
            newValue = $checkbox.prop('checked');

        //define Obj as property name chanes according to checkbox
        dataParams.RegimenId = $regimenId.val();
        dataParams[propertyName] = newValue;

        $.ajax({
            url: apiUrl,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'PUT',
            headers: {
                __RequestVerificationToken: token
            },
            data: JSON.stringify(dataParams),
            success: function (data) {

                window.location.href = data.href;
            },
            error: function (error) {

                loader.fadeOut();

                $.fancybox.close();

                toaster("Details couldn't be saved!");
            }
        });
    });

    let setDeliveryFeeType = function () {
        let type;

        if ($allDeliveryFree.prop('checked'))
            type = 2;
        else
            type = 0;

        return type;
    };

    /* set checkbox to original value, if user doesn't agree to change current value */
    let undoCheckbox = function ($checkbox) {
        if ($checkbox.is(':checked')) {
            $checkbox
                .prop('checked', false)
                .parent().removeClass('checked');
        } else {
            $checkbox
                .prop('checked', true)
                .parent().addClass('checked');
        }
    };


    /*
     * Showing input field "Purchase Order Number" in case "custom" option is selected from select options.
     * */
    $editBtnPurchaseOrder.on('click', function () {

        // Check if input field "Purchase Order Number" exists
        if ($('.po-number__container div.form-input').length > 0) {

            //checking the selected option has value "custom"
            if ($selectedPoNumber.val() === 'custom') {
                $('.po-number__container div.form-input').addClass('show');

            }
        }
    });

}
